import { useTranslation } from "react-i18next";

import { InputText, Text } from "@pentabd/ui";
import { HTMLInputTypeAttribute, ReactNode } from "react";

interface InputTextRowType {
  register: any;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  error?: any;
  required?: boolean;
  restriction?: boolean;
  prefix?: ReactNode;
  suffix?: ReactNode;
  type?: HTMLInputTypeAttribute;
  value?: string | number;
  controlling?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  onChange?: (value: string) => void;
}

export const InputTextRow = ({
  register,
  label,
  placeholder,
  disabled,
  error,
  required,
  restriction,
  prefix,
  suffix,
  type,
  value,
  controlling,
  size,
  onChange,
}: InputTextRowType) => {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div className="col-lg-3">
        <Text weight="semibold" color="title" size={size ? size : "sm"}>
          {t(`${label}.LABEL`)}
        </Text>
        {required && <span className="text-danger">&#42;</span>}
      </div>
      <div className="col-lg-7">
        <InputText
          {...register}
          size={size}
          placeholder={t(placeholder ? placeholder : `${label}.PLACEHOLDER`)}
          error={error}
          disabled={disabled}
          prefix={prefix}
          suffix={suffix}
          type={type ? type : "text"}
          value={value}
          controlling={controlling}
          onChange={(e) => {
            onChange && onChange(e.target.value);
          }}
        />
        {restriction && (
          <Text color="warning" size="xs">
            {t(`${label}.RESTRICTION`)}
          </Text>
        )}
      </div>
    </div>
  );
};
